import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import TenantManagement from '../../components/admin/TenantManagement';

const TenantsPage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <TenantManagement />
    </SuperAdminLayout>
  );
};

export default TenantsPage;